import { Component } from '@theme/component';

/**
 * @typedef {{ widget: HTMLElement }} Refs
 */

/** @extends {Component<Refs>} */
export class NaProductReviewsComponent extends Component {
    /** @type {string[]} */
    requiredRefs = ['widget'];

    #abortController = new AbortController();
    /** @type {MutationObserver | null} */
    #observer = null;
    /** @type {number} */
    #readyTimer = 0;

    connectedCallback() {
        super.connectedCallback();
        this.#bindYotpo();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.#abortController.abort();
        this.#observer?.disconnect();
        window.clearTimeout(this.#readyTimer);
    }

    #bindYotpo() {
        const widget = this.refs.widget;
        widget.setAttribute('aria-busy', 'true');

        this.#observer = new MutationObserver(() => {
            if (this.#hasRenderedReviews()) this.#markReady();
        });
        this.#observer.observe(widget, { childList: true, subtree: true });

        if (this.#yotpoAvailable()) {
            this.#initYotpo();
        } else {
            document.addEventListener('yotpo:loaded', () => this.#initYotpo(), {
                once: true,
                signal: this.#abortController.signal,
            });
        }

        this.#readyTimer = window.setTimeout(() => this.#markReady(), 15000);
    }

    #initYotpo() {
        window.yotpoWidgetsContainer?.initWidgets?.();
        window.yotpo?.refreshWidgets?.();
        if (this.#hasRenderedReviews()) this.#markReady();
    }

    #hasRenderedReviews() {
        return Boolean(
            this.refs.widget.querySelector(
                '.yotpo-reviews, .yotpo-main-reviews, .yotpo-review, .yotpo-display-l, .yotpo-display-s'
            )
        );
    }

    #yotpoAvailable() {
        return Boolean(window.yotpoLoaded || window.yotpo || window.yotpoWidgetsContainer);
    }

    #markReady() {
        this.refs.widget.setAttribute('aria-busy', 'false');
        this.#observer?.disconnect();
        window.clearTimeout(this.#readyTimer);
    }
}

if (!customElements.get('na-product-reviews-component')) {
    customElements.define('na-product-reviews-component', NaProductReviewsComponent);
}
